// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********** Template CSS **********/
:root {
    --primary: #009CFF;
    --light: #F3F6F9;
    --dark: #191C24;
}

.back-to-top {
    position: fixed;
    display: none;
    right: 45px;
    bottom: 45px;
    z-index: 99;
}


/*** Spinner ***/
#spinner {
    opacity: 0;
    visibility: hidden;
    transition: opacity .5s ease-out, visibility 0s linear .5s;
    z-index: 99999;
}

#spinner.show {
    transition: opacity .5s ease-out, visibility 0s linear 0s;
    visibility: visible;
    opacity: 1;
}


/*** Button ***/
.btn {
    transition: .5s;
}

.btn.btn-primary {
    color: #FFFFFF;
}

.btn-square {
    width: 38px;
    height: 38px;
}

.btn-sm-square {
    width: 32px;
    height: 32px;
}

.btn-lg-square {
    width: 48px;
    height: 48px;
}

.btn-square,
.btn-sm-square,
.btn-lg-square {
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: normal;
    border-radius: 50px;
}


/*** Layout ***/
.sidebar {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 270px;
    height: 100vh;
    overflow-y: auto;
    background: var(--light);
    transition: 0.5s;
    z-index: 999;
}

.content {
    margin-left: 270px;
    min-height: 100vh;
    background: #FFFFFF;
    transition: 0.5s;
}

@media (min-width: 992px) {
    .sidebar {
        margin-left: 0;
    }

    .sidebar.open {
        margin-left: -250px;
    }

    .content {
        width: calc(100% - 250px);
    }

    .content.open {
        width: 100%;
        margin-left: 0;
    }
}

@media (max-width: 991.98px) {
    .sidebar {
        margin-left: -250px;
    }

    .sidebar.open {
        margin-left: 0;
    }

    .content {
        width: 100%;
        margin-left: 0;
    }
}


/*** Navbar ***/
.sidebar .navbar .navbar-nav .nav-link {
    padding: 7px 20px;
    color: var(--dark);
    font-weight: 500;
    border-left: 3px solid var(--light);
    border-radius: 0 30px 30px 0;
    outline: none;
}

.sidebar .navbar .navbar-nav .nav-link:hover,
.sidebar .navbar .navbar-nav .nav-link.active {
    color: var(--primary);
    background: #b3afaf;
    border-color: var(--primary);
}

.sidebar .navbar .navbar-nav .nav-link i {
    width: 40px;
    height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #FFFFFF;
    border-radius: 40px;
}

.sidebar .navbar .navbar-nav .nav-link:hover i,
.sidebar .navbar .navbar-nav .nav-link.active i {
    background: var(--light);
}

.sidebar .navbar .dropdown-toggle::after {
    position: absolute;
    top: 15px;
    right: 15px;
    border: none;
    content: "\\f107";
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    transition: .5s;
}

.sidebar .navbar .dropdown-toggle[aria-expanded=true]::after {
    transform: rotate(-180deg);
}

.sidebar .navbar .dropdown-item {
    padding-left: 25px;
    border-radius: 0 30px 30px 0;
}

.content .navbar .navbar-nav .nav-link {
    margin-left: 25px;
    padding: 12px 0;
    color: var(--dark);
    outline: none;
}

.content .navbar .navbar-nav .nav-link:hover,
.content .navbar .navbar-nav .nav-link.active {
    color: var(--primary);
}

.content .navbar .sidebar-toggler,
.content .navbar .navbar-nav .nav-link i {
    width: 40px;
    height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #FFFFFF;
    border-radius: 40px;
}

.content .navbar .dropdown-toggle::after {
    margin-left: 6px;
    vertical-align: middle;
    border: none;
    content: "\\f107";
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    transition: .5s;
}

.content .navbar .dropdown-toggle[aria-expanded=true]::after {
    transform: rotate(-180deg);
}



/*** Date Picker ***/
.bootstrap-datetimepicker-widget.bottom {
    top: auto !important;
}

.bootstrap-datetimepicker-widget .table * {
    border-bottom-width: 0px;
}

.bootstrap-datetimepicker-widget .table th {
    font-weight: 500;
}

.bootstrap-datetimepicker-widget.dropdown-menu {
    padding: 10px;
    border-radius: 2px;
}

.bootstrap-datetimepicker-widget table td.active,
.bootstrap-datetimepicker-widget table td.active:hover {
    background: var(--primary);
}

.bootstrap-datetimepicker-widget table td.today::before {
    border-bottom-color: var(--primary);
}


/*** Testimonial ***/
.progress .progress-bar {
    width: 0px;
    transition: 2s;
}


/*** Testimonial ***/
.testimonial-carousel .owl-dots {
    margin-top: 24px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
}

.testimonial-carousel .owl-dot {
    position: relative;
    display: inline-block;
    margin: 0 5px;
    width: 15px;
    height: 15px;
    border: 5px solid var(--primary);
    border-radius: 15px;
    transition: .5s;
}

.testimonial-carousel .owl-dot.active {
    background: var(--dark);
    border-color: var(--primary);
}

.container-xxl.position-relative.bg-white.d-flex.p-0 {
    min-width: 100%;
}

.add-edit-button {
    color: #0d6efc;
    margin-right: 13px;
    cursor: pointer;
}

.view-button {
    cursor: pointer;
}

.submit {
    width: 100%;
}

.report-form .row {
    margin-bottom: 12px;
}

.report-form input {
    height: 40px !important;
}

.form-floating>.form-control,
.form-floating>.form-control-plaintext,
.form-floating>.form-select {
    height: calc(3.5rem + calc(var(--bs-border-width)* 2));
    min-height: calc(2.5rem + calc(var(--bs-border-width)* 2));
    line-height: 0;
}

.form-floating>.form-control,
.form-floating>.form-control-plaintext {
    padding: 0.5rem .75rem;
}

.form-floating>label {
    padding: 0.7rem .75rem;
}

.form-floating>.form-control-plaintext~label,
.form-floating>.form-control:focus~label,
.form-floating>.form-control:not(:placeholder-shown)~label,
.form-floating>.form-select~label {
    color: rgba(var(--bs-body-color-rgb), .65);
    transform: scale(.85) translateY(-1.2rem) translateX(.15rem);
}

.form-floating {
    padding: 3px;
}

.form-floating>.form-control-plaintext:focus,
.form-floating>.form-control-plaintext:not(:placeholder-shown),
.form-floating>.form-control:focus,
.form-floating>.form-control:not(:placeholder-shown) {
    padding-top: .625rem;
    padding-bottom: .625rem;
}


@media (max-width: 575.98px) {
    .content .navbar .navbar-nav .nav-link {
        margin-left: 15px;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/admin/css/style.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;;AAGA,gBAAgB;AAChB;IACI,UAAU;IACV,kBAAkB;IAClB,0DAA0D;IAC1D,cAAc;AAClB;;AAEA;IACI,yDAAyD;IACzD,mBAAmB;IACnB,UAAU;AACd;;;AAGA,eAAe;AACf;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;;IAGI,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;;AAGA,eAAe;AACf;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,SAAS;IACT,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,cAAc;IAClB;AACJ;;;AAGA,eAAe;AACf;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mCAAmC;IACnC,4BAA4B;IAC5B,aAAa;AACjB;;AAEA;;IAEI,qBAAqB;IACrB,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,aAAa;AACjB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;;;AAIA,oBAAoB;AACpB;IACI,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,mCAAmC;AACvC;;;AAGA,oBAAoB;AACpB;IACI,UAAU;IACV,cAAc;AAClB;;;AAGA,oBAAoB;AACpB;IACI,gBAAgB;IAChB,aAAa;IACb,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;;IAGI,sDAAsD;IACtD,0DAA0D;IAC1D,cAAc;AAClB;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;;;IAII,0CAA0C;IAC1C,4DAA4D;AAChE;;AAEA;IACI,YAAY;AAChB;;AAEA;;;;IAII,oBAAoB;IACpB,uBAAuB;AAC3B;;;AAGA;IACI;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["/********** Template CSS **********/\r\n:root {\r\n    --primary: #009CFF;\r\n    --light: #F3F6F9;\r\n    --dark: #191C24;\r\n}\r\n\r\n.back-to-top {\r\n    position: fixed;\r\n    display: none;\r\n    right: 45px;\r\n    bottom: 45px;\r\n    z-index: 99;\r\n}\r\n\r\n\r\n/*** Spinner ***/\r\n#spinner {\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    transition: opacity .5s ease-out, visibility 0s linear .5s;\r\n    z-index: 99999;\r\n}\r\n\r\n#spinner.show {\r\n    transition: opacity .5s ease-out, visibility 0s linear 0s;\r\n    visibility: visible;\r\n    opacity: 1;\r\n}\r\n\r\n\r\n/*** Button ***/\r\n.btn {\r\n    transition: .5s;\r\n}\r\n\r\n.btn.btn-primary {\r\n    color: #FFFFFF;\r\n}\r\n\r\n.btn-square {\r\n    width: 38px;\r\n    height: 38px;\r\n}\r\n\r\n.btn-sm-square {\r\n    width: 32px;\r\n    height: 32px;\r\n}\r\n\r\n.btn-lg-square {\r\n    width: 48px;\r\n    height: 48px;\r\n}\r\n\r\n.btn-square,\r\n.btn-sm-square,\r\n.btn-lg-square {\r\n    padding: 0;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-weight: normal;\r\n    border-radius: 50px;\r\n}\r\n\r\n\r\n/*** Layout ***/\r\n.sidebar {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    bottom: 0;\r\n    width: 270px;\r\n    height: 100vh;\r\n    overflow-y: auto;\r\n    background: var(--light);\r\n    transition: 0.5s;\r\n    z-index: 999;\r\n}\r\n\r\n.content {\r\n    margin-left: 270px;\r\n    min-height: 100vh;\r\n    background: #FFFFFF;\r\n    transition: 0.5s;\r\n}\r\n\r\n@media (min-width: 992px) {\r\n    .sidebar {\r\n        margin-left: 0;\r\n    }\r\n\r\n    .sidebar.open {\r\n        margin-left: -250px;\r\n    }\r\n\r\n    .content {\r\n        width: calc(100% - 250px);\r\n    }\r\n\r\n    .content.open {\r\n        width: 100%;\r\n        margin-left: 0;\r\n    }\r\n}\r\n\r\n@media (max-width: 991.98px) {\r\n    .sidebar {\r\n        margin-left: -250px;\r\n    }\r\n\r\n    .sidebar.open {\r\n        margin-left: 0;\r\n    }\r\n\r\n    .content {\r\n        width: 100%;\r\n        margin-left: 0;\r\n    }\r\n}\r\n\r\n\r\n/*** Navbar ***/\r\n.sidebar .navbar .navbar-nav .nav-link {\r\n    padding: 7px 20px;\r\n    color: var(--dark);\r\n    font-weight: 500;\r\n    border-left: 3px solid var(--light);\r\n    border-radius: 0 30px 30px 0;\r\n    outline: none;\r\n}\r\n\r\n.sidebar .navbar .navbar-nav .nav-link:hover,\r\n.sidebar .navbar .navbar-nav .nav-link.active {\r\n    color: var(--primary);\r\n    background: #b3afaf;\r\n    border-color: var(--primary);\r\n}\r\n\r\n.sidebar .navbar .navbar-nav .nav-link i {\r\n    width: 40px;\r\n    height: 40px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background: #FFFFFF;\r\n    border-radius: 40px;\r\n}\r\n\r\n.sidebar .navbar .navbar-nav .nav-link:hover i,\r\n.sidebar .navbar .navbar-nav .nav-link.active i {\r\n    background: var(--light);\r\n}\r\n\r\n.sidebar .navbar .dropdown-toggle::after {\r\n    position: absolute;\r\n    top: 15px;\r\n    right: 15px;\r\n    border: none;\r\n    content: \"\\f107\";\r\n    font-family: \"Font Awesome 5 Free\";\r\n    font-weight: 900;\r\n    transition: .5s;\r\n}\r\n\r\n.sidebar .navbar .dropdown-toggle[aria-expanded=true]::after {\r\n    transform: rotate(-180deg);\r\n}\r\n\r\n.sidebar .navbar .dropdown-item {\r\n    padding-left: 25px;\r\n    border-radius: 0 30px 30px 0;\r\n}\r\n\r\n.content .navbar .navbar-nav .nav-link {\r\n    margin-left: 25px;\r\n    padding: 12px 0;\r\n    color: var(--dark);\r\n    outline: none;\r\n}\r\n\r\n.content .navbar .navbar-nav .nav-link:hover,\r\n.content .navbar .navbar-nav .nav-link.active {\r\n    color: var(--primary);\r\n}\r\n\r\n.content .navbar .sidebar-toggler,\r\n.content .navbar .navbar-nav .nav-link i {\r\n    width: 40px;\r\n    height: 40px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background: #FFFFFF;\r\n    border-radius: 40px;\r\n}\r\n\r\n.content .navbar .dropdown-toggle::after {\r\n    margin-left: 6px;\r\n    vertical-align: middle;\r\n    border: none;\r\n    content: \"\\f107\";\r\n    font-family: \"Font Awesome 5 Free\";\r\n    font-weight: 900;\r\n    transition: .5s;\r\n}\r\n\r\n.content .navbar .dropdown-toggle[aria-expanded=true]::after {\r\n    transform: rotate(-180deg);\r\n}\r\n\r\n\r\n\r\n/*** Date Picker ***/\r\n.bootstrap-datetimepicker-widget.bottom {\r\n    top: auto !important;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget .table * {\r\n    border-bottom-width: 0px;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget .table th {\r\n    font-weight: 500;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget.dropdown-menu {\r\n    padding: 10px;\r\n    border-radius: 2px;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table td.active,\r\n.bootstrap-datetimepicker-widget table td.active:hover {\r\n    background: var(--primary);\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table td.today::before {\r\n    border-bottom-color: var(--primary);\r\n}\r\n\r\n\r\n/*** Testimonial ***/\r\n.progress .progress-bar {\r\n    width: 0px;\r\n    transition: 2s;\r\n}\r\n\r\n\r\n/*** Testimonial ***/\r\n.testimonial-carousel .owl-dots {\r\n    margin-top: 24px;\r\n    display: flex;\r\n    align-items: flex-end;\r\n    justify-content: center;\r\n}\r\n\r\n.testimonial-carousel .owl-dot {\r\n    position: relative;\r\n    display: inline-block;\r\n    margin: 0 5px;\r\n    width: 15px;\r\n    height: 15px;\r\n    border: 5px solid var(--primary);\r\n    border-radius: 15px;\r\n    transition: .5s;\r\n}\r\n\r\n.testimonial-carousel .owl-dot.active {\r\n    background: var(--dark);\r\n    border-color: var(--primary);\r\n}\r\n\r\n.container-xxl.position-relative.bg-white.d-flex.p-0 {\r\n    min-width: 100%;\r\n}\r\n\r\n.add-edit-button {\r\n    color: #0d6efc;\r\n    margin-right: 13px;\r\n    cursor: pointer;\r\n}\r\n\r\n.view-button {\r\n    cursor: pointer;\r\n}\r\n\r\n.submit {\r\n    width: 100%;\r\n}\r\n\r\n.report-form .row {\r\n    margin-bottom: 12px;\r\n}\r\n\r\n.report-form input {\r\n    height: 40px !important;\r\n}\r\n\r\n.form-floating>.form-control,\r\n.form-floating>.form-control-plaintext,\r\n.form-floating>.form-select {\r\n    height: calc(3.5rem + calc(var(--bs-border-width)* 2));\r\n    min-height: calc(2.5rem + calc(var(--bs-border-width)* 2));\r\n    line-height: 0;\r\n}\r\n\r\n.form-floating>.form-control,\r\n.form-floating>.form-control-plaintext {\r\n    padding: 0.5rem .75rem;\r\n}\r\n\r\n.form-floating>label {\r\n    padding: 0.7rem .75rem;\r\n}\r\n\r\n.form-floating>.form-control-plaintext~label,\r\n.form-floating>.form-control:focus~label,\r\n.form-floating>.form-control:not(:placeholder-shown)~label,\r\n.form-floating>.form-select~label {\r\n    color: rgba(var(--bs-body-color-rgb), .65);\r\n    transform: scale(.85) translateY(-1.2rem) translateX(.15rem);\r\n}\r\n\r\n.form-floating {\r\n    padding: 3px;\r\n}\r\n\r\n.form-floating>.form-control-plaintext:focus,\r\n.form-floating>.form-control-plaintext:not(:placeholder-shown),\r\n.form-floating>.form-control:focus,\r\n.form-floating>.form-control:not(:placeholder-shown) {\r\n    padding-top: .625rem;\r\n    padding-bottom: .625rem;\r\n}\r\n\r\n\r\n@media (max-width: 575.98px) {\r\n    .content .navbar .navbar-nav .nav-link {\r\n        margin-left: 15px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
